import { useEffect, useState } from 'react';
import { Button, Modal } from '../../ui/components';

const SaveApplicationModal = ({
  open,
  onClose,
  initialEmail = '',
  saving = false,
  error = null,
  success = false,
  onSave,
}) => {
  const [email, setEmail] = useState(initialEmail);

  useEffect(() => {
    if (open) setEmail(initialEmail || '');
  }, [open, initialEmail]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(email);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Save your progress"
      size="sm"
      footer={(
        <>
          <Button type="button" variant="ghost" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button type="submit" form="lk-save-application-form" loading={saving} disabled={success}>
            {success ? 'Saved' : 'Save'}
          </Button>
        </>
      )}
    >
      <form id="lk-save-application-form" onSubmit={handleSubmit}>
        <p style={{ margin: '0 0 12px', color: 'var(--lk-text-secondary)', fontSize: 'var(--lk-text-sm)' }}>
          Enter your email and we will save your answers so you can pick up later. No password needed yet.
        </p>
        <label
          htmlFor="lk-save-email"
          style={{ display: 'block', fontSize: 'var(--lk-text-sm)', fontWeight: 600, marginBottom: 6 }}
        >
          Email address
        </label>
        <input
          id="lk-save-email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={saving || success}
          placeholder="you@example.com"
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid var(--lk-border-subtle, #e8ebf0)',
            fontSize: 'var(--lk-text-base)',
          }}
        />
        {error && (
          <p role="alert" style={{ margin: '10px 0 0', color: 'var(--lk-danger-600, #c92a2a)', fontSize: 'var(--lk-text-sm)' }}>
            {error}
          </p>
        )}
        {success && !error && (
          <p style={{ margin: '10px 0 0', color: 'var(--lk-success-600, #198754)', fontSize: 'var(--lk-text-sm)' }}>
            Your progress is saved. Use the same email when you return.
          </p>
        )}
      </form>
    </Modal>
  );
};

export default SaveApplicationModal;
